/**
 * HealthCategoryNav — persistent chip bar for all /health/* pages so
 * users can jump between top-level buckets.
 */
import { Link, NavLink } from "react-router-dom";
import {
  Home, Building2, Stethoscope, Pill, UserRound, HeartPulse,
  BookOpenText, Leaf, ScanLine, Beaker,
} from "lucide-react";

const TABS = [
  { to: "/health",             key: "home",       label: "Home",        icon: Home,          exact: true },
  { to: "/health/hospitals",   key: "hospitals",  label: "Hospitals",   icon: Building2 },
  { to: "/health/clinics",     key: "clinics",    label: "Clinics",     icon: Stethoscope },
  { to: "/health/pharmacies",  key: "pharmacies", label: "Pharmacies",  icon: Pill },
  { to: "/health/providers",   key: "providers",  label: "Providers",   icon: UserRound },
  { to: "/health/diseases",    key: "diseases",   label: "Diseases",    icon: HeartPulse },
  { to: "/health/procedures",  key: "procedures", label: "Procedures",  icon: ScanLine },
  { to: "/health/drugs",       key: "drugs",      label: "Drugs",       icon: Beaker },
  { to: "/health/wellness",    key: "wellness",   label: "Wellness",    icon: Leaf },
  { to: "/health/articles",    key: "articles",   label: "Articles",    icon: BookOpenText },
];

export default function HealthCategoryNav() {
  return (
    <nav
      className="sticky top-0 z-20 backdrop-blur-md border-b overflow-x-auto"
      style={{ background: "rgba(253,251,247,0.85)", borderColor: "var(--wofy-border)" }}
      data-testid="health-nav"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-1 px-3 py-2">
        <Link to="/health" className="inline-flex items-center gap-1 text-xs opacity-70 hover:opacity-100 pr-2 md:pr-3 border-r"
              style={{ borderColor: "var(--wofy-border)" }} data-testid="health-nav-brand">
          <HeartPulse className="w-3.5 h-3.5" /> Health
        </Link>
        {TABS.map(({ to, key, label, icon: Icon, exact }) => (
          <NavLink
            key={key} to={to} end={exact}
            className={({ isActive }) =>
              `whitespace-nowrap inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-full transition ${
                isActive ? "bg-black text-white" : "hover:bg-black/5"
              }`
            }
            data-testid={`health-nav-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
